import { render, staticRenderFns } from "./BasisForm.vue?vue&type=template&id=6f006e8b&scoped=true"
import script from "./BasisForm.vue?vue&type=script&lang=js"
export * from "./BasisForm.vue?vue&type=script&lang=js"
import style0 from "./BasisForm.vue?vue&type=style&index=0&id=6f006e8b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f006e8b",
  null
  
)

export default component.exports